
import Vue from 'vue';
import {Route} from 'vue-router';

interface Breadcrumb {
  text: string;
  to?: string;
  disabled: boolean;
}

export default Vue.extend({
  computed: {
    breadcrumbs(): Breadcrumb[] {
      return this.getBreadcrumbs(this.$route);
    },
  },
  methods: {
    getBreadcrumbs(route: Route): Breadcrumb[] {
      const breadcrumbs = [];
      if (route.meta && route.meta.breadcrumb) {
        const breadcrumbData = route.meta.breadcrumb(route);
        breadcrumbs.push(...breadcrumbData);
      }

      return breadcrumbs;
    },
  },
});
